export default "__VITE_ASSET__DyjQrgHZ__"